import { useEffect, useMemo } from 'react';
import { getBoardByKey } from '@/features/class/classRegistry';
import { registeredBoardToManagedClass } from '@/features/class/manage/classMappers';
import ClassShareModal from '@/features/class/manage/ClassShareModal';
import { useClassManageStore } from '@/features/class/manage/classManageStore';
import type { ManagedClass } from '@/features/class/manage/types';

export default function ClassShareModalHost() {
  const sharingClassId = useClassManageStore((state) => state.sharingClassId);
  const closeShareClass = useClassManageStore((state) => state.closeShareClass);
  const storeClass = useClassManageStore((state) =>
    sharingClassId ? state.classes.find((item) => item.id === sharingClassId) : undefined,
  );

  const classItem = useMemo<ManagedClass | null>(() => {
    if (!sharingClassId) {
      return null;
    }
    if (storeClass) {
      return storeClass;
    }
    const board = getBoardByKey(sharingClassId);
    return board ? registeredBoardToManagedClass(board) : null;
  }, [sharingClassId, storeClass]);

  useEffect(() => {
    if (sharingClassId && !classItem) {
      closeShareClass();
    }
  }, [sharingClassId, classItem, closeShareClass]);

  if (!sharingClassId || !classItem) {
    return null;
  }

  return <ClassShareModal classItem={classItem} onClose={closeShareClass} />;
}
